<script setup>

const props = defineProps({
    meta: Object,
    currentPage: Number,
});

defineEmits(['changePage']);

const previousPage = () => {
    if (props.currentPage <= 1) {
        return null;
    }

    return props.currentPage - 1;
}

const nextPage = () => {
    if (props.currentPage >= props.meta.last_page) {
        return null;
    }

    return props.currentPage + 1;
}
</script>

<template>
    <nav>
        <ul>
            <li>
                <button
                    class="previous"
                    :disabled="currentPage === 1"
                    @click="$emit('changePage', previousPage())"
                >➜
                </button>
            </li>
            <li v-for="page in meta['last_page']">
                <button v-if="page === currentPage" class="current">
                    {{ page }}
                </button>
                <button v-else @click="$emit('changePage', page)">
                    {{ page }}
                </button>
            </li>
            <li>
                <button
                    class="next"
                    :disabled="currentPage === meta['last_page']"
                    @click="$emit('changePage', nextPage())"
                >➜
                </button>
            </li>
        </ul>
    </nav>
</template>

<style scoped>

</style>
